import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import axios from "axios";
import { debounce } from "lodash";
import moment from "moment";
import parser from "ua-parser-js";

import { LoadingIcon, InLineLoading } from "../../Common/Loading_Icon";
import { setUserSession } from "../../../Actions/userSessionActions";
import {
  registrationCheckmark,
  registrationClose,
} from "../../Common/Buttons/Icons";
import {
  checkPasswordRequirements,
  checkPasswordsMatch,
  checkCharacterLength,
  checkUpperCaseLetter,
  checkLowerCaseLetter,
  checkNumber,
  checkSymbol,
} from "../../../Helpers/StringHelper";
import { Trans } from "react-i18next";

class Security extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.submitAction = debounce(this.submitAction.bind(this), 500);
    this.clearPasswords = this.clearPasswords.bind(this);

    this.state = {
      logins: [],
      loading_logins: true,
      current_password: null,
      password: null,
      password_confirmation: null,
      colours: { red: "#D55656", green: "#42B53A", grey: "#919EAB" },
    };
  }

  componentDidMount() {
    var self = this;

    document.title = "Profile Settings - FleetXPress";

    axios
      .get("ajax/pastloginhistory/" + this.props.userSession.user.profile_id)
      .then(function(response) {
        self.setState({
          logins: response?.data.logins,
          loading_logins: false,
        });
      })
      .catch(function(error) {
        if (error.response?.status == 401) {
          showStatusMsg(error.response?.data.error);
        } else if (error.response?.status == 422) {
          var error_message = "";

          $.each(error.response?.data.errors, function(index, element) {
            error_message += element + "<br />";
          });

          showStatusMsg(error_message);
        } else {
          showStatusMsg("Requested information not found");
        }
      });
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  submitAction() {
    var profile_id = this.props.userSession.user.profile_id;

    var self = this;

    axios({
      method: "post",
      url: "/ajax/password/" + profile_id + "/update",
      data: {
        id: profile_id,
        current_password: this.state.current_password,
        password: this.state.password,
        password_confirmation: this.state.password_confirmation,
      },
      config: { headers: { "Content-Type": "multipart/form-data" } },
    })
      .then(function(response) {
        showStatusMsg(response?.data.message, "success");
        self.props.dispatch(checkAuthenticated());
        var current_user = self.props.userSession.user;
        current_user.temp_password = false;
        self.props.dispatch(setUserSession(current_user));
        self.setState({
          current_password: null,
          password: null,
          password_confirmation: null,
        });
      })
      .catch(function(error) {
        if (error.response?.status == 401) {
          showStatusMsg(error.response?.data.error);
        } else if (error.response?.status == 422) {
          var error_message = "";

          $.each(error.response?.data.errors, function(index, element) {
            error_message += element + "<br />";
          });

          showStatusMsg(error_message);
        } else {
          showStatusMsg("Requested information not found");
        }
      });
  }

  clearPasswords() {
    this.setState({
      current_password: null,
      password: null,
      password_confirmation: null,
    });
  }

  render() {
    var password = this.state.password;
    var password_confirmation = this.state.password_confirmation;

    return (
      <div>
        <div className="password_container sectioned">
          <div className="settings_header">
            <div className="left_header"><Trans>Change Password</Trans></div>
          </div>
          <div className="passwords_area =">
            <div className="password_item">
              <div className="password_item_label"><Trans>Current Password</Trans></div>
              <input
                className="password_item_input"
                type="password"
                name="current_password"
                id="current_password"
                value={this.state.current_password}
                onChange={this.handleChange}
              />
            </div>
            <div className="password_item">
              <div className="password_item_label"><Trans>New Password</Trans></div>
              <input
                className={
                  "password_item_input" +
                  (password
                    ? checkPasswordRequirements(password)
                      ? " success"
                      : " error"
                    : "")
                }
                value={this.state.password}
                type="password"
                name="password"
                id="password"
                onChange={this.handleChange}
              />
              <div className="registration-password-confirms">
                <span
                  className={
                    "registration-password-check" +
                    (password
                      ? checkCharacterLength(password, 8)
                        ? " success"
                        : " error"
                      : "")
                  }
                  style={{ marginRight: "auto" }}
                >
                  {password ? (
                    checkCharacterLength(password, 8) ? (
                      <span className="password-icon">
                        {registrationCheckmark(this.state.colours.green)}
                      </span>
                    ) : (
                      <span className="password-icon">
                        {registrationClose(this.state.colours.red)}
                      </span>
                    )
                  ) : (
                    <span className="password-icon">
                      {registrationClose(this.state.colours.grey)}
                    </span>
                  )}
                  <span className="password-text"><Trans>At least 8 characters</Trans></span>
                </span>
                <span
                  className={
                    "registration-password-check" +
                    (password
                      ? checkUpperCaseLetter(password)
                        ? " success"
                        : " error"
                      : "")
                  }
                  style={{ marginRight: "10px" }}
                >
                  {password ? (
                    checkUpperCaseLetter(password) ? (
                      <span className="password-icon">
                        {registrationCheckmark(this.state.colours.green)}
                      </span>
                    ) : (
                      <span className="password-icon">
                        {registrationClose(this.state.colours.red)}
                      </span>
                    )
                  ) : (
                    <span className="password-icon">
                      {registrationClose(this.state.colours.grey)}
                    </span>
                  )}
                  <span className="password-text">
                    <Trans>At least 1 uppercase letter</Trans>
                  </span>
                </span>
              </div>
              <div className="registration-password-confirms">
                <span
                  className={
                    "registration-password-check" +
                    (password
                      ? checkNumber(password)
                        ? " success"
                        : " error"
                      : "")
                  }
                  style={{ marginRight: "auto" }}
                >
                  {password ? (
                    checkNumber(password) ? (
                      <span className="password-icon">
                        {registrationCheckmark(this.state.colours.green)}
                      </span>
                    ) : (
                      <span className="password-icon">
                        {registrationClose(this.state.colours.red)}
                      </span>
                    )
                  ) : (
                    <span className="password-icon">
                      {registrationClose(this.state.colours.grey)}
                    </span>
                  )}
                  <span className="password-text"><Trans>At least 1 number</Trans></span>
                </span>
                <span
                  className={
                    "registration-password-check" +
                    (password
                      ? checkLowerCaseLetter(password)
                        ? " success"
                        : " error"
                      : "")
                  }
                  style={{ marginRight: "10px" }}
                >
                  {password ? (
                    checkLowerCaseLetter(password) ? (
                      <span className="password-icon">
                        {registrationCheckmark(this.state.colours.green)}
                      </span>
                    ) : (
                      <span className="password-icon">
                        {registrationClose(this.state.colours.red)}
                      </span>
                    )
                  ) : (
                    <span className="password-icon">
                      {registrationClose(this.state.colours.grey)}
                    </span>
                  )}
                  <span className="password-text">
                    <Trans>At least 1 lowercase letter</Trans>
                  </span>
                </span>
              </div>
              <div className="registration-password-confirms">
                <span
                  className={
                    "registration-password-check" +
                    (password
                      ? checkSymbol(password)
                        ? " success"
                        : " error"
                      : "")
                  }
                  style={{ marginRight: "auto" }}
                >
                  {password ? (
                    checkSymbol(password) ? (
                      <span className="password-icon">
                        {registrationCheckmark(this.state.colours.green)}
                      </span>
                    ) : (
                      <span className="password-icon">
                        {registrationClose(this.state.colours.red)}
                      </span>
                    )
                  ) : (
                    <span className="password-icon">
                      {registrationClose(this.state.colours.grey)}
                    </span>
                  )}
                  <span className="password-text">
                    <Trans>At least 1 of the following symbols: ! @ # $ % * ? &</Trans>
                  </span>
                </span>
              </div>
            </div>
            <div className="password_item">
              <div className="password_item_label"><Trans>Confirm New Password</Trans></div>
              <input
                className={
                  "password_item_input" +
                  (password_confirmation
                    ? checkPasswordsMatch(password, password_confirmation)
                      ? " success"
                      : " error"
                    : "")
                }
                value={this.state.password_confirmation}
                type="password"
                name="password_confirmation"
                id="password_confirmation"
                onChange={this.handleChange}
              />
              {password_confirmation &&
              !checkPasswordsMatch(password, password_confirmation) ? (
                <div className="registration-password-confirms">
                  <span
                    className={"registration-password-check error"}
                    style={{ marginRight: "auto" }}
                  >
                    <span className="password-icon">
                      {registrationClose(this.state.colours.red)}
                    </span>
                    <span className="password-text">
                      <Trans>Passwords do not match</Trans>
                    </span>
                  </span>
                </div>
              ) : null}
            </div>
            <div className="mt-16">
              <div
                className="button secondary px-26 mr-8"
                onClick={this.clearPasswords}
              >
                <Trans>Cancel</Trans>
              </div>
              <div
                className="button primary px-26"
                onClick={this.submitAction}
                disabled={
                  !checkPasswordRequirements(password) ||
                  !checkPasswordsMatch(password, password_confirmation)
                }
              >
                <Trans>Save</Trans>
              </div>
            </div>
          </div>
        </div>
        <div className="login_history_container">
          <div className="settings_header">
            <div className="left_header"><Trans>Past Login History</Trans></div>
            <div className="right_header">
              * <Trans>History reflects 5 most recent logins</Trans>.
            </div>
          </div>
          {this.state.loading_logins ? (
            <div className="loading_logins_container">
              <InLineLoading />
            </div>
          ) : (
            <div className="login_history">
              <div className="login_header_row">
                <div className="login_left"><Trans>Browser/Device</Trans></div>
                <div className="login_center"><Trans>Location</Trans></div>
                <div className="login_right"><Trans>Recent Activity</Trans></div>
              </div>
              {this.state.logins.map((login) => {
                return (
                  <div className="login_row">
                    <div className="login_left">
                      <span>{parser(login.User_Agent).browser.name}</span>
                      <span>
                        {parser(login.User_Agent).os.name}{" "}
                        {parser(login.User_Agent).os.version}
                      </span>
                    </div>
                    <div className="login_center">
                      {login.Country && login.Region ? (
                        <span style={{ margin: "auto 0" }}>
                          {login.Region}, {login.Country}
                        </span>
                      ) : (
                        <span style={{ margin: "auto 0" }}>-</span>
                      )}
                    </div>
                    <div className="login_right">
                      {moment().diff(moment(login.Time), "days") === 0 ? (
                        moment().diff(moment(login.Time), "hours") === 0 ? (
                          <span style={{ margin: "auto 0" }}>
                            {moment().diff(moment(login.Time), "minutes")}{" "}
                            <Trans>minutes ago</Trans>
                          </span>
                        ) : (
                          <span style={{ margin: "auto 0" }}>
                            {moment().diff(moment(login.Time), "hours")} <Trans>hours</Trans>
                            <Trans>ago</Trans>
                          </span>
                        )
                      ) : moment().diff(moment(login.Time), "days") === 1 ? (
                        <span style={{ margin: "auto 0" }}>
                          {moment().diff(moment(login.Time), "days")} <Trans>day ago</Trans>
                        </span>
                      ) : (
                        <span style={{ margin: "auto 0" }}>
                          {moment().diff(moment(login.Time), "days")} <Trans>days ago</Trans>
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  userSession: store.userSession,
});

export default connect(mapStateToProps)(Security);
